import {
    container,
    title,
    main,
    mainRaised,
    mlAuto,
    description
} from "assets/jss/material-kit-pro-react.js";

const ContactStyle = (theme) => ({
    main,
    mainRaised,
    title,
    mlAuto,
    container: {
        ...container,
        maxWidth: "970px !important"
    },
    contactContent: {
        paddingBottom: "40px",
        paddingTop: "40px",
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '12px',
            paddingRight: '12px',
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '18px',
            paddingRight: '18px',
        }
    },
    bigMap: {
        height: "55vh",
        maxHeight: "550px",
        width: "100%",
        display: "block",
        position: "relative",
    },
    info: {
        paddingBottom: "10px",
        paddingTop: 0,
        marginLeft: 0,
    },
    textCenter: {
        textAlign: "center !important"
    },
});

export default ContactStyle;
